module.exports = __webpack_public_path__ + "static/media/wonik_event_entireEndIcon.0ae21613.svg";